export const SUV_METHOD_VERSION = 'suv-petfirst-trilinear-v2';
export const ROI_PARTIAL_VOLUME_THRESHOLD = 0.5;

const cache = new Map();  // global cache

export function setSuvSamples(key, entry) {
  if (!key) return;
  cache.set(key, entry);
}

export function getSuvSamples(key) {
  if (!key) return null;
  return cache.get(key) || null;
}

export function deleteSuvSamples(key) {
  if (!key) return;
  cache.delete(key);
}

export function clearAllSuvSamples() {
  cache.clear();
}

/** Debug helper: how many ROIs are cached, total voxel count. */
export function suvSampleCacheStats() {
  let voxels = 0;
  for (const entry of cache.values()) {
    voxels += entry.suv ? entry.suv.length : 0;
  }
  return { 
    entries: cache.size, 
    voxels, 
    keys: [...cache.keys()],
  };
}
